export enum RowSize {
  Two = 'colsTwo',
  Three = 'colsThree',
}

export enum ChildType {
  Default = 'default',
  TeaserTileLarge = 'teaserTileLarge',
}
